// packages/ui/src/components/CloseButton.tsx
import { IconButton, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslations } from 'next-intl';
import type { TFunc } from '@tourtask/types/i18n';

interface CloseButtonProps {
	handleClose: () => void;
	/**
	 * Translator override. Required in non-Next.js contexts (e.g. embed)
	 * where there is no `NextIntlClientProvider`. When omitted, falls back to
	 * `useTranslations()` from `next-intl`.
	 */
	t?: TFunc<'Close'>;
}

export function CloseButton({ handleClose, t }: CloseButtonProps) {
	if (t) return <CloseButtonInner handleClose={handleClose} t={t} />;
	return <CloseButtonWithIntl handleClose={handleClose} />;
}

function CloseButtonWithIntl({ handleClose }: { handleClose: () => void }) {
	const t = useTranslations('common');
	return <CloseButtonInner handleClose={handleClose} t={t} />;
}

function CloseButtonInner({ handleClose, t }: { handleClose: () => void; t: TFunc<'Close'> }) {
	return (
		<Tooltip title={t('Close')}>
			<IconButton
				aria-label={t('Close')}
				onClick={handleClose}
				sx={{
					width: 48,
					height: 48,
					borderRadius: '50%',
					color: 'inherit',
				}}
			>
				<CloseIcon />
			</IconButton>
		</Tooltip>
	);
}
